<header class="header-area site-header">
    <div class="top-header site-topbar">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-sm-6">
                    <ul class="left-info"></ul>
                </div>

                <div class="col-lg-6 col-sm-6">
                    <ul class="right-info">
                        <li><a href="https://www.facebook.com/" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="https://twitter.com/" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="https://in.linkedin.com/" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                        <li><a href="https://www.instagram.com/" target="_blank"><i class='bx bxl-instagram'></i></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="isShow">
        <div class="navbar-area site-navbar-area" [class.is-sticky]="isSticky">
            <div class="lemonmode-nav site-nav-shell">
                <div class="p-0">
                    <nav class="navbar navbar-expand-lg navbar-light site-navbar">
                        <a class="navbar-brand site-brand d-inline-flex align-items-center" routerLink="/"
                            (click)="closeMenu()">
                            <span class="site-brand__mark">
                                <img src="assets/img/lemonmode_logo.png" alt="logo">
                            </span>
                        </a>

                        <button class="navbar-toggler site-navbar-toggler d-lg-none" type="button"
                            (click)="toggleMenu()" [attr.aria-expanded]="isMenuOpen" aria-label="Toggle navigation">
                            <span class="navbar-toggler-icon"></span>
                        </button>

                        <div class="collapse navbar-collapse mean-menu" [class.show]="isMenuOpen">
                            <ul class="navbar-nav ms-auto site-nav-list align-items-lg-center gap-lg-1">
                                <li class="nav-item">
                                    <a routerLink="/" class="nav-link" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{exact: true}"
                                        (click)="closeMenu()"><span>Home</span></a>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/track-order" class="nav-link" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()"><span>Track
                                            Order</span></a>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/about" class="nav-link" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()"><span>About
                                            Us</span></a>
                                </li>

                                <li class="nav-item nav-item--dropdown"
                                    [class.dropdown-open]="isDropdownOpen('services')">
                                    <button type="button" class="nav-link nav-dropdown-toggle"
                                        [class.dropdown-toggle-open]="isDropdownOpen('services')"
                                        [attr.aria-expanded]="isDropdownOpen('services')"
                                        (click)="toggleDropdown('services', $event)">
                                        <span>Services</span>
                                        <i class='bx bx-chevron-down'></i>
                                    </button>

                                    <ul class="dropdown-menu" [class.show]="isDropdownOpen('services')">
                                        <li class="nav-item"><a routerLink="/services" class="nav-link"
                                                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                                                (click)="closeMenu()">All Services</a></li>
                                        <li class="nav-item"><a routerLink="/air-fright-services-details"
                                                class="nav-link" routerLinkActive="active"
                                                [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">Air
                                                fright</a></li>
                                        <li class="nav-item"><a routerLink="/ocean-fright-service-details"
                                                class="nav-link" routerLinkActive="active"
                                                [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">ocean
                                                fright</a></li>
                                        <li class="nav-item"><a routerLink="/road-fright-service-details"
                                                class="nav-link" routerLinkActive="active"
                                                [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">land
                                                transport</a></li>
                                        <li class="nav-item"><a routerLink="/cargo-storage-service-details"
                                                class="nav-link" routerLinkActive="active"
                                                [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">Cargo
                                                storage</a></li>
                                        <li class="nav-item"><a routerLink="/warehousing-service-details"
                                                class="nav-link" routerLinkActive="active"
                                                [routerLinkActiveOptions]="{exact: true}"
                                                (click)="closeMenu()">warehousing</a></li>
                                        <li class="nav-item"><a routerLink="/ecommerce-service-details" class="nav-link"
                                                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                                                (click)="closeMenu()">E-commerce solution</a></li>
                                        <li class="nav-item"><a routerLink="/express-service-details" class="nav-link"
                                                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                                                (click)="closeMenu()">Express Services</a></li>
                                        <li class="nav-item"><a routerLink="/domesticTrucking-service-details"
                                                class="nav-link" routerLinkActive="active"
                                                [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">Domestic
                                                trucking</a></li>
                                    </ul>
                                </li>

                                <li class="nav-item nav-item--dropdown"
                                    [class.dropdown-open]="isDropdownOpen('information')">
                                    <button type="button" class="nav-link nav-dropdown-toggle"
                                        [class.dropdown-toggle-open]="isDropdownOpen('information')"
                                        [attr.aria-expanded]="isDropdownOpen('information')"
                                        (click)="toggleDropdown('information', $event)">
                                        <span>Information</span>
                                        <i class='bx bx-chevron-down'></i>
                                    </button>

                                    <ul class="dropdown-menu" [class.show]="isDropdownOpen('information')">
                                        <li class="nav-item"><a routerLink="/prohibitedItems" class="nav-link"
                                                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                                                (click)="closeMenu()">Prohibited Items</a></li>
                                        <li class="nav-item"><a routerLink="/volumetric-weight-calculator"
                                                class="nav-link" routerLinkActive="active"
                                                [routerLinkActiveOptions]="{exact: true}"
                                                (click)="closeMenu()">Volumetric Weight Calculator</a></li>
                                        <li class="nav-item"><a routerLink="/rate-transit-times" class="nav-link"
                                                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                                                (click)="closeMenu()">Rate and Transit Times</a></li>
                                        <li class="nav-item"><a routerLink="/fuel-surcharge" class="nav-link"
                                                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                                                (click)="closeMenu()">Fuel Surcharge</a></li>
                                        <li class="nav-item"><a routerLink="/regulations" class="nav-link"
                                                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                                                (click)="closeMenu()">Regulations</a></li>
                                        <li class="nav-item"><a routerLink="/duties-taxes" class="nav-link"
                                                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                                                (click)="closeMenu()">Custom Duties and Taxes</a></li>
                                    </ul>
                                </li>

                                <li class="nav-item">
                                    <a routerLink="/contact" class="nav-link" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{exact: true}"
                                        (click)="closeMenu()"><span>Contact</span></a>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/admin/dashboard" class="nav-link" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{exact: true}"
                                        (click)="closeMenu()"><span>Dashboard</span></a>
                                </li>

                                <li class="nav-item nav-item--dropdown user-menu-item"
                                    [class.dropdown-open]="isDropdownOpen('user')">
                                    <button type="button" class="nav-link nav-dropdown-toggle nav-link--icon"
                                        [class.dropdown-toggle-open]="isDropdownOpen('user')"
                                        [attr.aria-expanded]="isDropdownOpen('user')"
                                        (click)="toggleDropdown('user', $event)">
                                        <i class='bx bx-user-circle'></i>
                                        <i class='bx bx-chevron-down d-lg-none'></i>
                                    </button>
                                    <ul class="dropdown-menu user-dropdown-menu" [class.show]="isDropdownOpen('user')">
                                        <li class="nav-item">
                                            <a class="nav-link logout-link" routerLinkActive="active" (click)="logOut()"
                                                [routerLinkActiveOptions]="{exact: true}">
                                                <!-- <i class='bx bx-log-out'></i> -->
                                                <span>Logout</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    </ng-container>
</header>